import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Reveal } from "@/components/Reveal";
import { useApp } from "@/context/AppContext";

export default function ChiSiamo() {
  const navigate = useNavigate();
  const { scrollToId } = useApp();
  useEffect(() => { window.scrollTo(0, 0); document.title = "Chi siamo · Martelli Rentals"; }, []);

  const goSection = (id) => { navigate("/"); setTimeout(() => scrollToId(id), 350); };

  return (
    <>
      <Header />
      <main className="pt-32 pb-24">
        <div className="max-w-6xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <Reveal>
            <img
              src="/images/chi-siamo/lorenzo-martelli-ponte-vecchio.webp"
              alt="Lorenzo Martelli, fondatore di Martelli Rentals, a Firenze"
              className="w-full aspect-[4/5] object-cover rounded-2xl"
            />
          </Reveal>
          <Reveal delay={100}>
            <p className="text-xs tracking-[0.35em] uppercase text-brand-gold mb-4">Il fondatore</p>
            <h1 className="font-heading font-light text-4xl md:text-5xl text-brand-black">Lorenzo Martelli</h1>
            <div className="mt-6 space-y-4 text-brand-brown leading-relaxed">
              <p>Martelli Rentals nasce dall’esperienza di Lorenzo Martelli nella gestione di appartamenti, dimore e strutture ricettive, con l’obiettivo di offrire soggiorni curati, semplici e autentici.</p>
              <p>Ogni struttura viene seguita con attenzione diretta, dalla preparazione dell’alloggio alla comunicazione con gli ospiti, fino all’assistenza durante il soggiorno.</p>
              <p>Parallelamente alla sua attività artistica internazionale come cantante lirico, Lorenzo ha sviluppato un progetto di ospitalità fondato sulla cura del dettaglio, sull’accoglienza e sul rapporto diretto con le persone.</p>
              <p>Il progetto riunisce proprietà diverse per stile e destinazione, accomunate dalla stessa idea di ospitalità: ambienti selezionati, informazioni chiare e un rapporto personale con ogni ospite.</p>
            </div>
          </Reveal>
        </div>

        <div className="max-w-3xl mx-auto px-6 md:px-12 mt-20">
          <h2 className="font-heading font-light text-3xl md:text-4xl text-brand-black">Un’ospitalità seguita personalmente</h2>
          <p className="mt-5 text-brand-brown leading-relaxed">Ogni struttura mantiene la propria identità, ma tutte condividono lo stesso metodo: preparazione accurata, comunicazione tempestiva, procedure di accesso semplici e assistenza presente prima, durante e dopo il soggiorno.</p>
          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <button data-testid="chisiamo-strutture" onClick={() => goSection("strutture")} className="bg-brand-olive text-white hover:bg-brand-black transition-colors rounded-full px-7 py-3.5 font-medium">Scopri le strutture</button>
            <button data-testid="chisiamo-contatti" onClick={() => goSection("contatti")} className="border border-brand-olive text-brand-olive hover:bg-brand-ivory transition-colors rounded-full px-7 py-3.5 font-medium">Contatta Martelli Rentals</button>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
